import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';
import Colors from '../../../layout/theme/utils/colors';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    iconSvg: {
      fill: Colors.navy,
      marginRight: theme.spacing(0.625),
    },
    disabledIconSvg: {
      fill: Colors.white,
      marginRight: theme.spacing(0.625),
    },
  }),
);
